import * as Yup from 'yup';

export const loginSchema = () => {
    const schema = Yup.object().shape({
        email: Yup.string().email('Invalid email').required('Email is required').trim(),
        password: Yup.string().required('Password is required').trim(),
    });

    return schema;
}